import React, { useState } from 'react'
import { getProjectByName } from '../../../../utils/mergeData';
import { Box, Card, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ProjectDashboardComponent } from '../../../common/cardComponent';
import { ChartComponent } from '../../../common/chartComponent';
import BiodiversityMap from '../../../../resources/images/biodevmap.png'
import { SiteCard } from '../../../common/detailComponent';
import { Link } from 'react-router-dom';
import areaCovered from '../../../../resources/images/site-area.png';
import plantationCovered from '../../../../resources/images/planted_area.png'
import treeCovered from '../../../../resources/images/tree (2).png'
import Mapbox from '../ProjectMap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import ProjectOverview from '../../../../resources/images/Project_overview.png'
import EnvPara from '../../../../resources/images/envparameter.png'
import CarbonStock from '../../../../resources/images/biomass&cstock.png'
import Emission from '../../../../resources/images/emission.png'
import DMapCA from '../DMap/DMapCA';
import DMapDashBoard from '../DMap/DMapDashboard';

const CarbonDashboard = () => {
    const selectedProjectStr = localStorage.getItem('selectedProject');
    const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;
    const currentProject = getProjectByName(selectedProject?.project_name);
    
    const [projectCarbon] = useState(currentProject ? [currentProject] : []);
    console.log('projectCarbon', projectCarbon)
    const filterGHGReductionData = projectCarbon[0]?.["estimated_ghg_emissions_removal/reductions"] || { unit: "tCO2e" };

    const transformedData = Object.entries(filterGHGReductionData)
        .filter(([key]) => key !== "unit") // Exclude the "unit" property
        .map(([key, value]) => ({
            name: key,
            value1: Number(value), // Ensure the value is a number
            value2: undefined, // Provide a placeholder for value2
            date: undefined
        }));
    const handleSelectSite = (site: any) => {
        localStorage.setItem('SelectedDropDownCarbonSite', JSON.stringify(site))
    }
    return (
        <Box sx={{ mt: 5 }}>
            <Box className='bio-map' mb={3}>
              {/* <DMapCA/> */}
              <DMapDashBoard/>
            </Box>

            <Box sx={{
                // maxHeight: '500px',
                border: '1px solid #ccc',
                // padding: '10px',
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
                marginTop: "5px"
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "22px", color: "#151E15", m: 2 }}>
                    {projectCarbon[0]?.project_name}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={1} />

                <Grid container spacing={4}>
                    <Grid size={{ xs: 6, md: 3 }} px={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1}}>
                            <Box
                                component="img"
                                src={ProjectOverview}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                                {'Project Details'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px",marginLeft:"40px"  }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Project Id'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.project_id}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Area'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.total_area}  {projectCarbon[0]?.total_area_unit}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Sites'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.number_of_sites}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 3 }}  px={1}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={EnvPara}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                            {'Environmental Parameters'}
                        </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px",marginLeft:"40px"  }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Average Temperature'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.temperature} {projectCarbon[0]?.temperature_unit}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Average Precipitation'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.precipitation} {projectCarbon[0]?.precipitation_unit}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Soil Type'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {projectCarbon[0]?.soil_type}
                                </Typography>
                            </Box>
                            <Box></Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 3 }}  px={1}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={CarbonStock}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                            {'Carbon Stock & Biomass'}
                        </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px",marginLeft:"40px"  }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Mean Biomass'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {Number(projectCarbon[0]?.total_mean_biomass || 0).toFixed(2)} {projectCarbon[0]?.total_mean_biomass_unit}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Total Mean Carbon Stock'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {Number(projectCarbon[0]?.total_mean_carbon_stock || 0).toFixed(2)} {projectCarbon[0]?.total_mean_carbon_stock_unit}
                                </Typography></Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 6, md: 3 }}  px={1}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box
                                component="img"
                                src={Emission}
                                alt="Project Overview"
                                sx={{
                                    width: "45px",
                                    height: "35px",
                                    objectFit: "contain", // Ensures the image fits within its dimensions
                                }}
                            />
                        <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#151E15", padding: "16px" }}>
                            {'Emission & Removals'}
                        </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #D9D9D9' }} gap={2} />
                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "16px",marginLeft:"40px" }} gap={2}>
                            <Box>
                                <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                    {'Estimated GHG Baseline Emissions'}
                                </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {Number(projectCarbon[0]?.estimated_ghg_baseline_emissions || 0).toFixed(2)} {projectCarbon[0]?.estimated_ghg_baseline_emissions_unit}
                                </Typography>
                            </Box>
                            <Box> <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                {'Total Removals'}
                            </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {Number(projectCarbon[0]?.total_removals || 0).toFixed(2)} {projectCarbon[0]?.total_removals_unit}
                                </Typography></Box>
                            <Box><Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
                                {'Annual Removals'}
                            </Typography>
                                <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
                                    {Number(projectCarbon[0]?.average_annual_removals || 0).toFixed(2)} {projectCarbon[0]?.average_annual_removals_unit}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Grid size={{ lg: 4, md: 6 }} sx={{ marginTop: '10px' }}>
                <ChartComponent chartType={'area'} chartTitle={'Estimated GHG Emissions reduction/removals'} data={transformedData} title=' tCO2e' seriesValue1=' tCO2e' yTitle='Year' />
            </Grid>

            <Typography sx={{ fontSize: "24px", fontWeight: 600, color: "#151E15", margin: "5px" }}>{'Project Sites'}</Typography>
            <Box sx={{
                display: 'flex',
                gap: 2,
                p: 1,
            }}>
                <Swiper navigation={true} modules={[Navigation]} spaceBetween={30}
                slidesPerView={3}
                breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10, 
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 20, 
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  }}  style={{ width: '100%' }}
                    >
                    {projectCarbon && projectCarbon[0]?.sites.map((site: any, index: any) => {
                        return (
                            <SwiperSlide>
                                <Link to={`/carbonanalysis-analysis-detail`} style={{ textDecoration: 'none' }} key={index} state={site} onClick={() => handleSelectSite(site)}>
                                    <Card className="card-hover" sx={{ display: 'flex', backgroundColor: "#151E15", borderRadius: 2, overflow: 'hidden' }}>
                                        <Box sx={{ flex: 1 }}>
                                            <CardMedia
                                                component="img"
                                                sx={{ height: '100%', objectFit: 'cover' }}
                                                image={BiodiversityMap}
                                                alt="Site image"
                                            />
                                        </Box>

                                        <Box sx={{
                                            display: 'flex', flexDirection: 'column', padding: 2, gap: 1.5,
                                            flex: 1
                                        }}>
                                            <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#fff" }}>
                                                {site.site_name}
                                            </Typography>
                                            <Typography sx={{ fontWeight: 600, fontSize: "15px", color: "#fff" }}>
                                                {site.type}
                                            </Typography>

                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                                                {/* Area Covered */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                    <img src={areaCovered} alt="area covered" style={{ width: 20, height: 20, color: "#" }} />
                                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                            {'Area Covered'}
                                                        </Typography>
                                                        <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                            {Number(site?.total_area || 0).toFixed(2)} {site.total_area_unit}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                {/* Cameras Installed */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                    <img src={plantationCovered} alt="camera installed" style={{ width: 20, height: 20 }} />
                                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                            {'Total Plantation Area'}
                                                        </Typography>
                                                        <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                            {Number(site.total_plantation_area || 0).toFixed(2)} {site.total_plantation_area_unit}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                {/* Audio Devices */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: '#fff' }}>
                                                    <img src={treeCovered} alt="audio devices" style={{ width: 20, height: 20 }} />
                                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                        <Typography component="div" sx={{ fontSize: "12px", fontWeight: 500 }}>
                                                            {'Total Planted Trees'}
                                                        </Typography>
                                                        <Typography component="div" sx={{ fontSize: "18px", fontWeight: 600 }}>
                                                            {site.total_planted_trees}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>

                                        </Box>
                                    </Card>
                                </Link>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </Box>
            {/* </Box> */}
            {/* </Box> */}
        </Box>
    )
}

export default CarbonDashboard